import type { TFunction } from "i18next";

function humanizeSecurityIdentifier(identifier: string) {
  return identifier
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * The translated MyGeotab label of a security identifier (`clearances.securityIdentifiers.<id>`).
 * Identifiers without a translation fall back to a humanized id ("HosLogs" -> "Hos Logs").
 */
export function getSecurityIdentifierLabel(identifier: string, t: TFunction) {
  return t(`clearances.securityIdentifiers.${identifier}`, {
    defaultValue: humanizeSecurityIdentifier(identifier),
  });
}
